import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestCookieGroupOrderPut = {
    path: "/cookie-groups/order",
    method: RouteHttpVerb.PUT
};
export { locationRestCookieGroupOrderPut };
